import { styles, useStyles } from '@signavio/ui'

export const GlobalHeaderFallback = () => {
  const style = useStyles(
    ({ color, padding, font, lineHeight }) => ({
      position: 'relative',
      backgroundColor: color.header.primary,
      height: styles.calculateHeight(
        font.size.normal,
        lineHeight,
        padding.normal
      ),
    }),
    {}
  )

  return <div {...style}></div>
}
